// CSS Variable Names for Dropzone Styling
export const CSS_VARIABLES = {
  // Wide dropzone CSS variables
  DROPZONE_WIDE_SKEW_X: '--dropzone-wide-skewX',
  DROPZONE_WIDE_ROTATE_Y: '--dropzone-wide-rotateY',
  DROPZONE_WIDE_ROTATE_X: '--dropzone-wide-rotateX',
  DROPZONE_WIDE_ROTATE_Z: '--dropzone-wide-rotateZ',
  DROPZONE_WIDE_WIDTH: '--dropzone-wide-width',
  DROPZONE_WIDE_HEIGHT: '--dropzone-wide-height',

  // Left dropzone CSS variables
  DROPZONE_LEFT_SKEW_X: '--dropzone-left-skewX',
  DROPZONE_LEFT_ROTATE_Y: '--dropzone-left-rotateY',
  DROPZONE_LEFT_ROTATE_X: '--dropzone-left-rotateX',
  DROPZONE_LEFT_ROTATE_Z: '--dropzone-left-rotateZ',
  DROPZONE_LEFT_WIDTH: '--dropzone-left-width',
  DROPZONE_LEFT_HEIGHT: '--dropzone-left-height',
  DROPZONE_LEFT_TOP: '--dropzone-left-top',

  // Right dropzone CSS variables
  DROPZONE_RIGHT_SKEW_X: '--dropzone-right-skewX',
  DROPZONE_RIGHT_ROTATE_Y: '--dropzone-right-rotateY',
  DROPZONE_RIGHT_ROTATE_X: '--dropzone-right-rotateX',
  DROPZONE_RIGHT_ROTATE_Z: '--dropzone-right-rotateZ',
  DROPZONE_RIGHT_WIDTH: '--dropzone-right-width',
  DROPZONE_RIGHT_HEIGHT: '--dropzone-right-height',
  DROPZONE_RIGHT_TOP: '--dropzone-right-top',

  // Stacks configuration CSS variables
  STACKS_REAR_WIDTH: '--stacks-rear-width',
  STACKS_REAR_LEFT: '--stacks-rear-left',
  STACKS_REAR_BOTTOM: '--stacks-rear-bottom',
  STACKS_REAR_TRANSLATE_X: '--stacks-rear-translateX',
  STACKS_REAR_GAP: '--stacks-rear-gap',

  STACKS_FRONT_WIDTH: '--stacks-front-width',
  STACKS_FRONT_LEFT: '--stacks-front-left',
  STACKS_FRONT_BOTTOM: '--stacks-front-bottom',
  STACKS_FRONT_TRANSLATE_X: '--stacks-front-translateX',
  STACKS_FRONT_GAP: '--stacks-front-gap',

  STACKS_SINGLE_WIDTH: '--stacks-single-width',
  STACKS_SINGLE_LEFT: '--stacks-single-left',
  STACKS_SINGLE_BOTTOM: '--stacks-single-bottom',
  STACKS_SINGLE_TRANSLATE_X: '--stacks-single-translateX',
  STACKS_SINGLE_GAP: '--stacks-single-gap',

  // left
  STACKS_LEFT_GAP: '--stacks-left-gap',
  STACKS_LEFT_MARGIN_BOTTOM: '--stacks-left-margin-bottom',
  STACKS_LEFT_LEFT: '--stacks-left-left',
  STACKS_LEFT_BOTTOM: '--stacks-left-bottom',

  // right
  STACKS_RIGHT_GAP: '--stacks-right-gap',
  STACKS_RIGHT_MARGIN_BOTTOM: '--stacks-right-margin-bottom',
  STACKS_RIGHT_RIGHT: '--stacks-right-right',
  STACKS_RIGHT_BOTTOM: '--stacks-right-bottom',

  // wide front/rear
  DROPZONE_WIDE_FRONT_TRANSLATE_X: '--dropzone-wide-front-translateX',
  DROPZONE_WIDE_FRONT_TRANSLATE_Y: '--dropzone-wide-front-translateY',
  DROPZONE_WIDE_REAR_TRANSLATE_X: '--dropzone-wide-rear-translateX',
  DROPZONE_WIDE_REAR_TRANSLATE_Y: '--dropzone-wide-rear-translateY',
  DROPZONE_WIDE_FRONT_ARROW_RIGHT: '--dropzone-wide-front-arrow-right',
  DROPZONE_WIDE_FRONT_ARROW_BOTTOM: '--dropzone-wide-front-arrow-bottom',
  DROPZONE_WIDE_REAR_ARROW_RIGHT: '--dropzone-wide-rear-arrow-right',
  DROPZONE_WIDE_REAR_ARROW_BOTTOM: '--dropzone-wide-rear-arrow-bottom',

  // front-left
  DROPZONE_FRONT_LEFT_TRANSLATE_X: '--dropzone-front-left-translateX',
  DROPZONE_FRONT_LEFT_TRANSLATE_Y: '--dropzone-front-left-translateY',
  DROPZONE_FRONT_LEFT_ARROW_RIGHT: '--dropzone-front-left-arrow-right',
  DROPZONE_FRONT_LEFT_ARROW_BOTTOM: '--dropzone-front-left-arrow-bottom',

  // front-right
  DROPZONE_FRONT_RIGHT_TRANSLATE_X: '--dropzone-front-right-translateX',
  DROPZONE_FRONT_RIGHT_TRANSLATE_Y: '--dropzone-front-right-translateY',
  DROPZONE_FRONT_RIGHT_ARROW_RIGHT: '--dropzone-front-right-arrow-right',
  DROPZONE_FRONT_RIGHT_ARROW_BOTTOM: '--dropzone-front-right-arrow-bottom',

  // rear-left
  DROPZONE_REAR_LEFT_TRANSLATE_X: '--dropzone-rear-left-translateX',
  DROPZONE_REAR_LEFT_TRANSLATE_Y: '--dropzone-rear-left-translateY',
  DROPZONE_REAR_LEFT_ARROW_RIGHT: '--dropzone-rear-left-arrow-right',
  DROPZONE_REAR_LEFT_ARROW_BOTTOM: '--dropzone-rear-left-arrow-bottom',

  // rear-right
  DROPZONE_REAR_RIGHT_TRANSLATE_X: '--dropzone-rear-right-translateX',
  DROPZONE_REAR_RIGHT_TRANSLATE_Y: '--dropzone-rear-right-translateY',
  DROPZONE_REAR_RIGHT_ARROW_RIGHT: '--dropzone-rear-right-arrow-right',
  DROPZONE_REAR_RIGHT_ARROW_BOTTOM: '--dropzone-rear-right-arrow-bottom',

  // full
  DROPZONE_FULL_WIDTH: '--dropzone-full-width',
  DROPZONE_FULL_HEIGHT: '--dropzone-full-height',
  DROPZONE_FULL_TRANSLATE_X: '--dropzone-full-translateX',
  DROPZONE_FULL_TRANSLATE_Y: '--dropzone-full-translateY',
  DROPZONE_FULL_SKEW_X: '--dropzone-full-skewX',
  DROPZONE_FULL_ROTATE_X: '--dropzone-full-rotateX',
  DROPZONE_FULL_ROTATE_Y: '--dropzone-full-rotateY',
  DROPZONE_FULL_ROTATE_Z: '--dropzone-full-rotateZ',
  DROPZONE_FULL_ARROW_RIGHT: '--dropzone-full-arrow-right',
  DROPZONE_FULL_ARROW_BOTTOM: '--dropzone-full-arrow-bottom'
};

// CSS Units
export const CSS_UNITS = {
  DEGREES: 'deg',
  PERCENTAGE: '%',
  REM: 'rem'
};

// Default Values for CSS Properties
export const DEFAULT_VALUES = {
  // Wide dropzone defaults
  WIDE_SKEW_X: { value: -45, unit: CSS_UNITS.DEGREES },
  WIDE_ROTATE_Y: { value: 30, unit: CSS_UNITS.DEGREES },
  WIDE_ROTATE_X: { value: -65, unit: CSS_UNITS.DEGREES },
  WIDE_ROTATE_Z: { value: 15, unit: CSS_UNITS.DEGREES },
  WIDE_WIDTH: { value: 21, unit: CSS_UNITS.REM },
  WIDE_HEIGHT: { value: 6.6, unit: CSS_UNITS.REM },

  // Left dropzone defaults
  LEFT_SKEW_X: { value: -25, unit: CSS_UNITS.DEGREES },
  LEFT_ROTATE_Y: { value: 30, unit: CSS_UNITS.DEGREES },
  LEFT_ROTATE_X: { value: -65, unit: CSS_UNITS.DEGREES },
  LEFT_ROTATE_Z: { value: 15, unit: CSS_UNITS.DEGREES },
  LEFT_WIDTH: { value: 10.5, unit: CSS_UNITS.REM },
  LEFT_HEIGHT: { value: 6.6, unit: CSS_UNITS.REM },

  // Right dropzone defaults
  RIGHT_SKEW_X: { value: -25, unit: CSS_UNITS.DEGREES },
  RIGHT_ROTATE_Y: { value: 30, unit: CSS_UNITS.DEGREES },
  RIGHT_ROTATE_X: { value: -65, unit: CSS_UNITS.DEGREES },
  RIGHT_ROTATE_Z: { value: 15, unit: CSS_UNITS.DEGREES },
  RIGHT_WIDTH: { value: 10.5, unit: CSS_UNITS.REM },
  RIGHT_HEIGHT: { value: 6.6, unit: CSS_UNITS.REM },

  // Stacks configuration defaults
  STACKS_REAR_WIDTH: { value: 20, unit: CSS_UNITS.REM },
  STACKS_REAR_LEFT: { value: -54, unit: CSS_UNITS.PERCENTAGE },
  STACKS_REAR_BOTTOM: { value: -1.8, unit: CSS_UNITS.REM },
  STACKS_REAR_TRANSLATE_X: { value: -32, unit: CSS_UNITS.PERCENTAGE },
  STACKS_REAR_GAP: { value: 0, unit: CSS_UNITS.REM },

  STACKS_FRONT_WIDTH: { value: 20, unit: CSS_UNITS.REM },
  STACKS_FRONT_LEFT: { value: 61, unit: CSS_UNITS.PERCENTAGE },
  STACKS_FRONT_BOTTOM: { value: -5, unit: CSS_UNITS.REM },
  STACKS_FRONT_TRANSLATE_X: { value: -85, unit: CSS_UNITS.PERCENTAGE },
  STACKS_FRONT_GAP: { value: 0, unit: CSS_UNITS.REM },

  STACKS_SINGLE_WIDTH: { value: 20, unit: CSS_UNITS.REM },
  STACKS_SINGLE_LEFT: { value: 80, unit: CSS_UNITS.PERCENTAGE },
  STACKS_SINGLE_BOTTOM: { value: 100, unit: CSS_UNITS.PERCENTAGE },
  STACKS_SINGLE_TRANSLATE_X: { value: -86, unit: CSS_UNITS.PERCENTAGE },
  STACKS_SINGLE_GAP: { value: 0, unit: CSS_UNITS.REM },

  // Left
  STACKS_LEFT_GAP: { value: 0, unit: CSS_UNITS.REM },
  STACKS_LEFT_MARGIN_BOTTOM: { value: 0, unit: CSS_UNITS.REM },
  STACKS_LEFT_LEFT: { value: 6.2, unit: CSS_UNITS.REM },
  STACKS_LEFT_BOTTOM: { value: 1.2, unit: CSS_UNITS.REM },

  // Right
  STACKS_RIGHT_GAP: { value: 0, unit: CSS_UNITS.REM },
  STACKS_RIGHT_MARGIN_BOTTOM: { value: 0, unit: CSS_UNITS.REM },
  STACKS_RIGHT_RIGHT: { value: -0.8, unit: CSS_UNITS.REM },
  STACKS_RIGHT_BOTTOM: { value: -0.1, unit: CSS_UNITS.REM },

  // wide front/rear
  WIDE_FRONT_TRANSLATE_X: { value: 0, unit: CSS_UNITS.PERCENTAGE },
  WIDE_FRONT_TRANSLATE_Y: { value: 0, unit: CSS_UNITS.PERCENTAGE },
  WIDE_REAR_TRANSLATE_X: { value: 0, unit: CSS_UNITS.PERCENTAGE },
  WIDE_REAR_TRANSLATE_Y: { value: 0, unit: CSS_UNITS.PERCENTAGE },
  WIDE_FRONT_ARROW_RIGHT: { value: 0, unit: CSS_UNITS.REM },
  WIDE_FRONT_ARROW_BOTTOM: { value: 0, unit: CSS_UNITS.REM },
  WIDE_REAR_ARROW_RIGHT: { value: 0, unit: CSS_UNITS.REM },
  WIDE_REAR_ARROW_BOTTOM: { value: 0, unit: CSS_UNITS.REM },

  // front-left
  FRONT_LEFT_TRANSLATE_X: { value: 0, unit: CSS_UNITS.PERCENTAGE },
  FRONT_LEFT_TRANSLATE_Y: { value: 0, unit: CSS_UNITS.PERCENTAGE },
  FRONT_LEFT_ARROW_RIGHT: { value: 0, unit: CSS_UNITS.REM },
  FRONT_LEFT_ARROW_BOTTOM: { value: 0, unit: CSS_UNITS.REM },

  // front-right
  FRONT_RIGHT_TRANSLATE_X: { value: 0, unit: CSS_UNITS.PERCENTAGE },
  FRONT_RIGHT_TRANSLATE_Y: { value: 0, unit: CSS_UNITS.PERCENTAGE },
  FRONT_RIGHT_ARROW_RIGHT: { value: 0, unit: CSS_UNITS.REM },
  FRONT_RIGHT_ARROW_BOTTOM: { value: 0, unit: CSS_UNITS.REM },

  // rear-left
  REAR_LEFT_TRANSLATE_X: { value: 0, unit: CSS_UNITS.PERCENTAGE },
  REAR_LEFT_TRANSLATE_Y: { value: 0, unit: CSS_UNITS.PERCENTAGE },
  REAR_LEFT_ARROW_RIGHT: { value: 0, unit: CSS_UNITS.REM },
  REAR_LEFT_ARROW_BOTTOM: { value: 0, unit: CSS_UNITS.REM },

  // rear-right
  REAR_RIGHT_TRANSLATE_X: { value: 0, unit: CSS_UNITS.PERCENTAGE },
  REAR_RIGHT_TRANSLATE_Y: { value: 0, unit: CSS_UNITS.PERCENTAGE },
  REAR_RIGHT_ARROW_RIGHT: { value: 0, unit: CSS_UNITS.REM },
  REAR_RIGHT_ARROW_BOTTOM: { value: 0, unit: CSS_UNITS.REM },

  // full
  FULL_WIDTH: { value: 23, unit: CSS_UNITS.REM },
  FULL_HEIGHT: { value: 18, unit: CSS_UNITS.REM },
  FULL_TRANSLATE_X: { value: 7, unit: CSS_UNITS.PERCENTAGE },
  FULL_TRANSLATE_Y: { value: 34, unit: CSS_UNITS.PERCENTAGE },
  FULL_SKEW_X: { value: 116, unit: CSS_UNITS.DEGREES },
  FULL_ROTATE_X: { value: 281, unit: CSS_UNITS.DEGREES },
  FULL_ROTATE_Y: { value: 3, unit: CSS_UNITS.DEGREES },
  FULL_ROTATE_Z: { value: 34, unit: CSS_UNITS.DEGREES },
  FULL_ARROW_RIGHT: { value: 7, unit: CSS_UNITS.REM },
  FULL_ARROW_BOTTOM: { value: 7, unit: CSS_UNITS.REM }
};
